import { addDocuments, addAnswers } from './tools'

const documents = {
    'cell0.about': [
        'cell0',
        'wie zijn jullie',
        'cell-0, wat is dat',
        'meer over het bedrijf',
    ],
    'cell0.contact': [
        'hoe kan ik contact met jullie opnemen',
        'hoe kan ik cell[0] bereiken',
        'wat zijn de contactgegevens',
        'zitten jullie in het klokgebouw',
        'zitten jullie in eindhoven',
        'kan ik bellen',
        'kan ik mailen',
        'kan ik bertus spreken',
        'waar gaat de post naar toe',
    ],
    'cell0.member': [
        'wie is hij',
        'wie is zij',
        'wie is %member%',
        'wie is %member%',
        'vertel eens iets over %member%',
        '%member% werkt bij jullie',
        'profiel %member%',
        'eigenaar %member%',
    ],
    'cell0.history': [
        'hoe lang bestaan jullie al',
        'hoe lang bestaat cell[0]',
        'historie van het bedrijf',
    ],
}

const answers = {
    'cell0.about': [
        'Cell[0] is een collectief van programmeurs in Eindhoven.',
    ],
    'cell0.contact': [
        // answered by intent card
    ],
    'cell0.member': [
        '{{member}} is mede-eigenaar van Cell[0].',
    ],
    'cell0.history': [
        'In 2013 richtten 7 vrienden Cell[0] op als collectief. Wij leerden onszelf programmeren en plukken daar tot de dag van vandaag de vruchten van. We hebben ons allemaal steeds verder ontwikkeld, waardoor er ook echt specialismen zijn ontstaan. Sinds die tijd is er veel veranderd, maar de opzet en het vrije gedachtegoed zijn hetzelfde gebleven.',
    ],
}

const members = {
    'Diede Gulpers': [
        'diede', 'gulpers',
    ],
    'Annemarieke van Maris': [
        'anne', 'annemarieke', 'anne-marieke', 'van maris',
    ],
    'Tomas Pieters': [
        'tomas', 'thomas', 'pieters',
    ],
    'Bertus van Gerwen': [
        'bertus', 'van gerwen', 'brutus',
    ],
    'Matijs Eijkemans': [
        'matijs', 'matthijs', 'mathijs', 'eijkemans', 'ijkemans', 'eikemans',
    ],
    'Edgar van Ispelen': [
        'edgar', 'van ispelen', 'edje raketje',
    ],
    'Benoit Dupont': [
        'benoit', 'dupont', 'du pont',
    ],
}

export default function (manager) {
    addDocuments(manager, documents, 'nl')
    addAnswers(manager, answers, 'nl')

    Object.keys(members).forEach((member) => {
        manager.nerManager.addNamedEntityText('member', member, ['nl'], members[member])
    })

    manager.slotManager.addSlot('cell0.member', 'member', true, { nl: 'Van wie wil je iets weten?' })
}
